<template>
  <div id="CreateUpdateUser">
    <v-dialog max-width="600" scrollable persistent v-model="userDialog">
      <v-card>
        <v-card-title >{{ user ? 'Update' : 'Create' }} User</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="py-3">
          <v-form ref="form">
            <v-row>
              <v-col class="py-1 mt-5" cols="12">
                <v-text-field :rules="[rules.nameRequired]" dense label="Name*" outlined
                              ref="name" v-model="userData.name"></v-text-field>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-text-field :rules="[rules.mobileRequired,rules.mobileLength]" dense label="Mobile*"
                              v-mask="'##########'" outlined ref="mobile" v-model="userData.mobile"></v-text-field>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-text-field :rules="[rules.emailValid]" dense label="Email"
                              outlined ref="email" v-model="userData.email"></v-text-field>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-select :items="userTypes" :rules="[rules.userTypeRequired]" dense item-text="name"
                          item-value="id" label="User Type*" outlined ref="userType"
                          v-model="userData.userTypeId"></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn @click="cancel" class="mr-2 white elevation-0">CANCEL</v-btn>
          <v-btn @click="validate" class="mr-2 primary elevation-0">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GET_USER_TYPES } from '../../graphql/queries/UserTypes'
import { CREATE_UPDATE_USER } from '../../graphql/mutations/Users'
import { GET_USER_BY_MOBILE } from '@/graphql/queries/Users'

export default {
  name: 'CreateUpdateUser',
  props: {
    user: { type: [Object], default: null },
    userDialog: { type: [Boolean], default: false },
  },
  data () {
    return {
      userData: { name: '', userTypeId: '', mobile: '', email: '' },
      userTypes: [],
      loggedInUser: JSON.parse(localStorage.user),
      rules: {
        nameRequired: value => !!value || 'Name Required.',
        mobileRequired: value => !!value || 'Mobile Required.',
        mobileLength: v => v ? v.length === 10 : 'Must be 10 characters',
        emailValid: v => !v ||
            /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                v) || 'E-mail must be valid',
        userTypeRequired: value => !!value || 'User Type Required.',
      },
    }
  },
  apollo: {
    UserTypes: {
      query: GET_USER_TYPES, fetchPolicy: 'network-only',
      result ({ data, loading }) { if (!loading) { this.userTypes = data.UserTypes } },
    },
  },
  mounted () {
    if (this.user)
      this.userData = JSON.parse(JSON.stringify(this.user))
    else
      this.userData['id'] = this.generateUUID()
  },
  methods: {
    validate () {
      if (this.$refs.form.validate())
        this.checkMobileDuplication()
    },
    async checkMobileDuplication () {
      let response = await this.$apollo.query({
        query: GET_USER_BY_MOBILE, fetchPolicy: 'network-only',
        variables: {
          id: this.userData.id,
          mobile: this.userData.mobile,
        },
      })
      if (response.data) {
        if (response.data.Users.length)
          this.$emit('error', 'Mobile Already Exists')
        else
          this.saveUser()
      }
    },
    async saveUser () {
      let userObj = {
        id: this.userData.id,
        name: this.userData.name,
        email: this.userData.email,
        mobile: this.userData.mobile,
        userTypeId: this.userData.userTypeId,
        organizationId: this.loggedInUser.organizationId,
      }
      let user_on_conflict_rule = {
        constraint: 'Users_pkey',
        update_columns: ['name', 'email', 'mobile', 'organizationId', 'userTypeId', 'status', 'updatedBy'],
      }
      let response = await this.$apollo.mutate({
        mutation: CREATE_UPDATE_USER,
        variables: { users: userObj, user_on_conflict_rule: user_on_conflict_rule },
      })
      if (response.data)
        this.$emit('saveUser')
    },
    cancel () {
      this.$emit('cancel')
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
  },
}
</script>

<style scoped>
/deep/ .v-card__text {
  padding: 0 20px 0 !important;
}
</style>
